import { render } from "./AppContent.vue?vue&type=template&id=47313a36&scoped=true&ts=true"
import script from "./AppContent.vue?vue&type=script&lang=ts"
export * from "./AppContent.vue?vue&type=script&lang=ts"

import "./AppContent.vue?vue&type=style&index=0&id=47313a36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47313a36"]])

export default __exports__